package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.repository.CommentRepository
import com.example.readingnotes.util.Result

class BulkDeleteCommentsUseCase(
    private val commentRepository: CommentRepository,
) {
    suspend operator fun invoke(ids: List<String>, totpCode: String? = null): Result<Int> {
        if (ids.isEmpty()) {
            return Result.failure(IllegalArgumentException("削除するコメントを選択してください"))
        }
        if (ids.size > 100) {
            return Result.failure(IllegalArgumentException("一度に削除できるコメントは100件までです"))
        }
        return commentRepository.bulkDeleteComments(ids, totpCode)
    }
}
